// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"6701f803","256":"b4a77b29","268":"1e001156","688":"d0740a32","880":"86729c15","912":"728a3f1d"}[chunkId] + ".chunk.js";
};